export type RiskClassType = "DOSSIER" | "FZ115" | "P375";
